import { Svg } from 'components/svg'
import { FC, SVGAttributes } from 'react'

export const IconClose: FC<SVGAttributes<SVGSVGElement>> = props => (
  <Svg {...props} viewBox="0 0 30 30">
    <path
      d="M1.44727 1.48792L28.5529 28.5936"
      stroke="currentColor"
      strokeWidth="2.15"
      strokeLinecap="round"
    />
    <path
      d="M1.44727 28.5939L28.5529 1.48821"
      stroke="currentColor"
      strokeWidth="2.15"
      strokeLinecap="round"
    />
  </Svg>
)
